import router from "./router_en";
const routerModel = {
    router
};

export default routerModel;
